<template>
  <div>
    <PrimaryBox>
      <template slot="title">路况信息</template>
      <div v-if="WarningList.length">
        <vueSeamlessScroll :data="WarningList" class="content" :class-option="defaultOption">
          <div>
            <div class="warningBox" v-for="(item,index) in WarningList" :key="index" @click="showModal(item)">
              <img class="img" :src="IconRedList[0]"/>
              <p class="title">{{ item.title }}</p>
              <p class="type">区县:{{ item.deptName }}</p>
              <p class="times">{{ $moment(item.eventReceptionTime).format('MM-DD') }}</p>
            </div>
          </div>
        </vueSeamlessScroll>
      </div>
      <div v-else>
        <div style="width: 100%;height: 25vh;text-align: center;line-height: 25vh;">
          <span style="color: #2b85e4;font-size: .9rem;font-weight: bold;">暂无数据</span>
        </div>
      </div>
    </PrimaryBox>
    <Modal v-model="modalIsShow" footer-hide transfer>
      <el-descriptions :title="modalData.title" direction="horizontal" :column="1">
        <el-descriptions-item label="预警标题">{{ modalData.title }}</el-descriptions-item>
        <el-descriptions-item label="所属区县">{{ modalData.deptName }}</el-descriptions-item>
        <el-descriptions-item label="内容">
          <div v-html="modalData.content"></div>
        </el-descriptions-item>
        <el-descriptions-item label="上传时间">{{
            $moment(modalData.effectiveDate).format('yyyy-MM-DD HH:mm:ss')
          }}
        </el-descriptions-item>
        <el-descriptions-item label="封面">
          <el-image style="max-height: 100px;max-width: 100px" :src="modalData.cover"></el-image>
        </el-descriptions-item>
        <!--        <el-descriptions-item label="预警标题">{{ modalData.title }}</el-descriptions-item>-->
      </el-descriptions>
    </Modal>
  </div>
</template>

<script>
import PrimaryBox from "@/views/Screen/components/PrimaryBox/PrimaryBox";
import vueSeamlessScroll from "vue-seamless-scroll";
import IconRed from "@/views/Screen/images/iconRed.png";
import IconYellow from "@/views/Screen/images/iconYellow.png";
import IconBlue from "@/views/Screen/images/iconBlue.png";
import IconOrange from "@/views/Screen/images/iconOrange.png";

export default {
  name: "EarlyWarning",
  components: {
    PrimaryBox,
    vueSeamlessScroll
  },
  computed: {
    defaultOption() {
      return {
        step: 0.2, // 数值越大速度滚动越快
        limitMoveNum: 5, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
      }
    }
  },
  data() {
    return {
      modalIsShow: false,
      IconRedList: [IconRed, IconYellow, IconBlue, IconOrange],
      WarningList: [],
      modalData: {}
    }
  },
  mounted() {
    this.getWarningList();
  },
  methods: {
    // 弹窗
    showModal(item) {
      console.log(item)
      this.modalData = item;
      this.modalIsShow = true;
    },
    getWarningList() {
      this.$http.post("/api/getScreenNewsReleasesList", {
        reportingChannels: 1
      }).then(res => {
        if (res.status === 200) {
          this.WarningList = res.data.data;
        }
      });
    }
  }
}
</script>

<style scoped lang="less">
@import "EarlyWarning.less";
</style>
